<template>
<FormKitLazyProvider config-file="true">

  <div>
    <div class="max-w-screen-tablet">
      <FormKitWebform
        v-if="webform.form"
        :form="webform.form"
        :settings="webform.settings"
        :submit-form="submitForm"
        form-class="grid"
        @success="onSuccess"
      />
    </div>
  </div>

</FormKitLazyProvider>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type {
  WebformSubmissionResultFragment,
  WebformFragment,
  SubmitWebformMutationVariables,
} from '#graphql-operations'
import type { MutationVariables } from '~~/layers/webform-formkit/app/types/webform'

const props = defineProps<{
  webform: WebformFragment
  sourceEntityId?: string
  sourceEntityType?: string
}>()

async function submitForm(
  input: MutationVariables,
): Promise<WebformSubmissionResultFragment> {
  if (!props.webform?.id) {
    throw new Error('Missing webform ID')
  }
  const elements = input.elements.map((v) => {
    return {
      element: v.element,
      value: v.value,
    }
  })

  const files = input.files.map((v) => {
    return {
      element: v.element,
      file: v.value,
    }
  })

  const variables: SubmitWebformMutationVariables = {
    id: props.webform.id,
    elements,
    files,
    sourceEntityType: props.sourceEntityType,
    sourceEntityId: props.sourceEntityId,
  }

  const { data, errors } = await useGraphqlUploadMutation(
    'submitWebform',
    variables,
  )

  if (!data || errors?.length) {
    throw new Error('Failed to submit webform.')
  }

  return data.submitWebform
}

function onSuccess(data: { redirectUrl?: string }) {
  if (data.redirectUrl) {
    return navigateTo(data.redirectUrl, { external: true })
  }
}
</script>

<style lang="postcss">
.formkit-section {
  margin: 2.375rem 0;
  padding: 2.375rem 0;
  border-bottom: 2px solid #000;
  border-top: 2px solid #000;
}

.formkit-section + .formkit-section {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}

.formkit-section-title {
  @apply font-bold text-scheme-invert;
  margin-bottom: 0.75em;
}

.formkit-actions {
  @apply border-t border-solid border-border;
  padding: 1rem 0;
}

.formkit-flexbox {
  @apply tablet:flex;
  margin: 0 -0.5rem;

  & .formkit-outer {
    flex: 1;
    padding: 0 0.5rem;
  }
}
</style>
